

import "./ContestCard.scss";

import { RiTimerFill } from "react-icons/ri";
import { MdRemoveRedEye } from "react-icons/md";
import { HiOutlineChevronRight } from "react-icons/hi";
import CLink from "../CLink";

import contestThumbnail from "../../assets/contest.jpg?w=300&h=200&format=webp";


type ContestCardType = {
    name: string;
    description: string;
    startTime: string;
    endTime: string | null | undefined;
    timedContest: boolean;
    slug: string;
    enableProctored: boolean;
    duration: number | null | undefined;
    skeleton?: boolean;
}

export default function ContestCard(props: ContestCardType) {
    function textToShow(startTime: string, endTime: string | null | undefined): string {
        let startTimeAsDate = new Date(startTime);
        let endTimeAsDate;

        const now = new Date();

        if (typeof endTime === "string") {
            endTimeAsDate = new Date(endTime);
        }

        const timeDiff = (date1: Date, date2: Date) => {
            const diffMs = date1.getTime() - date2.getTime();
            const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
            const diffHours = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const diffMinutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
            const diffSeconds = Math.floor((diffMs % (1000 * 60)) / 1000);

            if (diffDays > 0) {
                return `${diffDays} day${diffDays !== 1 ? 's' : ''}`;
            } else if (diffHours > 0) {
                return `${diffHours} hour${diffHours !== 1 ? 's' : ''}`;
            } else if (diffMinutes > 0) {
                return `${diffMinutes} minute${diffMinutes !== 1 ? 's' : ''}`;
            } else {
                return `${diffSeconds} second${diffSeconds !== 1 ? 's' : ''}`;
            }
        };

        if (now < startTimeAsDate) {
            return `Starts in ${timeDiff(startTimeAsDate, now)}`;
        } else if (endTimeAsDate && now > endTimeAsDate) {
            return `Ended ${timeDiff(now, endTimeAsDate)} ago`;
        } else if (endTimeAsDate) {
            return `Ends in ${timeDiff(endTimeAsDate, now)}`;
        } else {
            return `Ongoing`;
        }
    }
    
    return (
        <div className="ContestCard">

            <div className={`imageContainer ${(props.skeleton) && "loading"}`}>
                <img src={contestThumbnail} alt="Contest Logo" />
                <span className="time">
                    {
                        textToShow(props.startTime, props.endTime)
                    }
                </span>
            </div>
            <div className="text">
                <h3 
                    className={`title ${(props.skeleton) && "loading"}`}
                    data-tooltip-id="tt"
                    data-tooltip-content={(props.name.length > 30) ? props.name : ""}
                >
                    {props.name}
                </h3>
                <p className={`description ${(props.skeleton) && "loading"}`}>{props.description}</p>
            </div>


            <div className="buttons">

                <div className="left">
                    {
                        (!props.skeleton) && (
                            <CLink 
                                to={`/contests/${props.slug}`} 
                                className={`visit ${(props.skeleton) && "loading"}`}
                            >
                                Visit
                                <HiOutlineChevronRight />
                            </CLink>
                        )
                    }
                    
                </div>

                <div className="right">
                    {
                        (props.enableProctored) && 
                        (<div 
                            className={`proctored ${(props.skeleton) && "loading"}`}
                            data-tooltip-id="tt" 
                            data-tooltip-content={(!props.skeleton) ? "Proctored Contest" : ""}
                        >
                            <MdRemoveRedEye size={"20px"} />
                        </div>)
                    }
                    {
                        (props.timedContest) && (
                        <div
                            className={`timed ${(props.skeleton) && "loading"}`}
                            data-tooltip-id="tt"
                            data-tooltip-content={(!props.skeleton) ? `Timed Contest (${props.duration} mins)` : ""}
                        >
                            <RiTimerFill size={"20px"} />
                        </div>)
                    }
                </div>
            </div>
        </div>
    );
}